import { useState, useEffect } from 'react';
import { LessonType, VideoProvider } from '../apis/api-client';
import { storageClient } from '../apis/client-instances';

export function useVideoPlayback(lesson: any) {
  const [videoPlayback, setVideoPlayback] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  // Fetch signed video playback token when lesson changes.
  // Only Mux-hosted videos need a signed token; external providers (e.g. Wistia)
  // are embedded directly via their own player and don't hit our storage endpoint.
  useEffect(() => {
    const fetchVideoPlayback = async () => {
      const isMuxVideo =
        lesson?.lessonType === LessonType.Video &&
        lesson?.id &&
        (lesson?.videoProvider == null || lesson?.videoProvider === VideoProvider.Mux);

      if (isMuxVideo) {
        setLoading(true);
        try {
          const playbackData = await storageClient.getVideoPlayback(lesson.id);
          setVideoPlayback(playbackData);
        } catch (error) {
          console.error('Failed to fetch video playback:', error);
        } finally {
          setLoading(false);
        }
      } else {
        setVideoPlayback(null);
        setLoading(false);
      }
    };
    fetchVideoPlayback();
  }, [lesson]);

  return { videoPlayback, loading };
}
